import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Box, Typography, Button, Grid, Avatar, Chip, Skeleton } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import axios from "axios";
import { getT } from "../i18n";
import CamEmbedModal from "./CamEmbedModal";
import { PreRollAd } from "./TwinredPreRoll";

const blink = keyframes`0%{opacity:0}50%{opacity:1}100%{opacity:0}`;
const LiveDot = styled("span")({ height:9, width:9, backgroundColor:"#4CAF50",
  borderRadius:"50%", display:"inline-block", marginRight:6,
  animation:`${blink} 1.5s ease-in-out infinite` });

const WatchBtn = styled(Button)({
  background:"linear-gradient(45deg,#FF6B6B,#FF2BAA)",
  borderRadius:"50px", color:"#fff", padding:"14px 36px",
  fontWeight:900, fontSize:"1rem", textTransform:"none",
  boxShadow:"0 4px 20px rgba(255,65,150,0.35)",
  "&:hover":{filter:"brightness(1.1)"},
});

const CATEGORY_SLUGS = [
  { slug:"latina-cam-girls",   filter:{ethnicity:"hispanic"}, icon:"🌶️" },
  { slug:"blonde-cam-girls",   filter:{hairColor:"blond"},    icon:"👱‍♀️" },
  { slug:"brunette-cam-girls", filter:{hairColor:"brunette"}, icon:"🤎" },
  { slug:"milf-cam-girls",     filter:{theme:"milf"},         icon:"🔥" },
  { slug:"teen-cam-girls",     filter:{ageMin:18,ageMax:21},  icon:"✨" },
  { slug:"ebony-cam-girls",    filter:{ethnicity:"ebony"},    icon:"♠️" },
  { slug:"asian-cam-girls",    filter:{ethnicity:"asian"},    icon:"🌸" },
  { slug:"mature-cam-girls",   filter:{ageMin:40},            icon:"👑" },
];

const catKey = slug => slug.replace("-cam-girls","");

const LangHomePage = () => {
  const location = useLocation();
  const t = getT(location.search);
  const [performers, setPerformers] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [selected, setSelected]     = useState(null);
  const [preRoll, setPreRoll]       = useState(false);
  const [liveCount] = useState(800 + Math.floor(Math.random()*200));

  // Build API params from lang (fetch Language-filtered performers)
  const langParam = t.lang !== 'en' ? t.lang : null;

  useEffect(() => {
    document.title = t.siteTitle;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.content = t.metaDesc;
    const html = document.documentElement;
    html.setAttribute('lang', t.htmlLang);
  }, [t]);

  useEffect(() => {
    const params = { limit: 18 };
    if (langParam) params.language = langParam;
    axios.get(`${process.env.REACT_APP_API_URL}/api/performers`, { params })
      .then(r => {
        const list = Array.isArray(r.data) ? r.data : [];
        setPerformers(list.map(p => {
          const a = p["@attributes"] || {};
          return {
            displayName: a.Name, uniqueModelId: a.Id,
            profilePictureUrl: (p?.Media?.Pic?.Thumb?.["@attributes"]?.Src || "").replace(/^\/\//, "https://"),
            goldShow: !!(a.PerfFlag && (parseInt(a.PerfFlag) & 0x00100000)),
            hdStream: !!(a.PerfFlag && (parseInt(a.PerfFlag) & 0x10000000)),
            chatRoomUrl: `https://instacamgirlslive.com/cam/${a.Name}/?smid=${a.Id}&AFNO=1-94033`,
            embedUrl: `https://hybridclient.naiadsystems.com/purecam?performer=${a.Name}&widescreen=true`,
          };
        }));
      }).catch(()=>{})
      .finally(()=>setLoading(false));
  }, [langParam]);

  const handleWatch = (p) => { setSelected(p); setPreRoll(true); };

  return (
    <Box sx={{ minHeight:"100vh", bgcolor:"#fafafa" }}>
      {preRoll && selected && (
        <PreRollAd onComplete={() => setPreRoll(false)} />
      )}
      {!preRoll && selected && (
        <CamEmbedModal performer={selected} allPerformers={performers}
          onClose={() => setSelected(null)} />
      )}

      {/* Hero */}
      <Box sx={{ background:"linear-gradient(135deg,#1a1a2e 0%,#16213e 50%,#0f3460 100%)",
        py:{ xs:5, md:8 }, px:2, textAlign:"center" }}>
        {/* Language switcher */}
        <Box sx={{ position:"absolute", top:16, right:16, display:"flex", gap:1 }}>
          {[['🇺🇸','en'],['🇫🇷','fr'],['🇪🇸','es'],['🇩🇪','de']].map(([flag,lg])=>(
            <Box key={lg} component="a" href={`/?lg=${lg}`}
              sx={{ fontSize:"1.4rem", cursor:"pointer", opacity: t.lang===lg ? 1 : 0.5,
                textDecoration:"none", "&:hover":{opacity:1} }}>
              {flag}
            </Box>
          ))}
        </Box>

        <Box sx={{ display:"flex", alignItems:"center", justifyContent:"center", mb:1.5 }}>
          <LiveDot />
          <Typography sx={{ color:"#4CAF50", fontWeight:700, fontSize:"0.9rem" }}>
            {liveCount} {t.girlsOnline}
          </Typography>
        </Box>

        <Typography variant="h2" sx={{ fontWeight:900, color:"#fff", mb:1,
          fontSize:{ xs:"2rem", md:"3rem" },
          background:"linear-gradient(90deg,#FF6B6B,#FF2BAA)",
          WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>
          {t.headline}
        </Typography>
        <Typography sx={{ color:"#aaa", fontSize:"1.1rem", mb:3 }}>
          {t.subheadline}
        </Typography>

        <WatchBtn component="a" href={`https://instacamgirlslive.com/signup?AFNO=1-94033`}
          target="_blank" startIcon={<LiveTvIcon />}>
          {t.joinFree}
        </WatchBtn>
        <Typography sx={{ color:"#555", fontSize:"0.75rem", mt:1 }}>{t.joinSub}</Typography>
      </Box>

      {/* Categories */}
      <Box sx={{ maxWidth:960, mx:"auto", px:2, py:4 }}>
        <Typography variant="h5" sx={{ fontWeight:800, mb:2 }}>{t.categories}</Typography>
        <Box sx={{ display:"flex", gap:1, overflowX:"auto", pb:1, mb:3 }}>
          {CATEGORY_SLUGS.map(cat => {
            const key = catKey(cat.slug);
            const label = t.catLabels?.[key] || key;
            return (
              <Box key={cat.slug} component={Link} to={`/category/${cat.slug}`}
                sx={{ textDecoration:"none", flexShrink:0,
                  px:2, py:1, borderRadius:"20px", border:"1px solid #FF4196",
                  color:"#FF4196", fontWeight:700, fontSize:"0.85rem", whiteSpace:"nowrap",
                  "&:hover":{ bgcolor:"#FF4196", color:"#fff" }, transition:"0.15s" }}>
                {cat.icon} {label}
              </Box>
            );
          })}
        </Box>

        {/* Performer grid — plain HTML for reliability */}
        <Typography variant="h5" sx={{ fontWeight:800, mb:2 }}>
          {t.trending} 🔥
        </Typography>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px, 1fr))', gap:12 }}>
          {loading ? Array(12).fill(0).map((_,i)=>(
            <Skeleton key={i} variant="rectangular" height={200} style={{ borderRadius:8 }} />
          )) : performers.map(p => (
            <div key={p.uniqueModelId} style={{ borderRadius:8, overflow:'hidden', position:'relative',
              cursor:'pointer', background:'#111' }}
              onClick={() => handleWatch(p)}>
              <img
                src={p.profilePictureUrl}
                alt={p.displayName}
                style={{ width:'100%', height:180, objectFit:'cover', display:'block' }}
                onError={(e) => { e.target.style.display='none'; }}
              />
              <div style={{ position:'absolute', top:6, left:6, background:'rgba(76,175,80,0.9)',
                borderRadius:10, padding:'2px 7px', display:'flex', alignItems:'center', gap:4 }}>
                <span style={{ height:7, width:7, background:'#fff', borderRadius:'50%', display:'inline-block' }} />
                <span style={{ color:'#fff', fontSize:10, fontWeight:700 }}>{t.liveNow.toUpperCase()}</span>
              </div>
              {p.goldShow && (
                <div style={{ position:'absolute', top:6, right:6, background:'#FFD700',
                  borderRadius:10, padding:'1px 6px', fontSize:10, fontWeight:700 }}>🥇</div>
              )}
              <div style={{ padding:'6px 8px', background:'#fff' }}>
                <Link to={`/cam/${p.displayName}`}
                  style={{ textDecoration:'none', color:'#000', fontWeight:700, fontSize:13 }}>
                  {p.displayName}
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA banner */}
        <Box sx={{ mt:5, p:3, borderRadius:2,
          background:"linear-gradient(135deg,#FF6B6B,#FF2BAA)",
          textAlign:"center", color:"#fff" }}>
          <Typography variant="h5" sx={{ fontWeight:900, mb:1 }}>
            {t.signupHeadline} — {t.signupSub} 🎉
          </Typography>
          <Button variant="contained" size="large"
            href={`https://instacamgirlslive.com/signup?AFNO=1-94033`}
            target="_blank"
            sx={{ bgcolor:"#fff", color:"#FF2BAA", fontWeight:900, borderRadius:"50px",
              px:4, "&:hover":{ bgcolor:"#f5f5f5" } }}>
            {t.joinFree} →
          </Button>
        </Box>
      </Box>

    </Box>
  );
};

export default LangHomePage;
